import React, { useState, useEffect } from "react";

// import JS files
import MuiModal from "../../mui/MuiModal";
import MuiButton from "../../mui/MuiButton";
import useFetch from "../../../context/useFetch";
// import Others files

const ReturnModal = ({
  width,
  isOverflow,
  isNotBackdropClick,
  openModal,
  setOpenModal,
  disableEscapeKeyDown = true,
  data,
  apiCall,
  // disableBackdropClick = true,
}) => {
  return (
    <>
      <MuiModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        width={width}
        isOverflow={isOverflow}
        isNotBackdropClick={isNotBackdropClick}
        disableEscapeKeyDown={disableEscapeKeyDown}
        // disableBackdropClick={disableBackdropClick}
      >
        <p className="text-myblack-100">آیا از انتقال بیمه‌شده به وضعیت منتظر تایید اطمینان دارید؟</p>
        <div className="flex items-center mt-4 justify-end">
          <div className="ml-2">
            <MuiButton
              onClick={() => apiCall.reFetch()}
              variant="outlined"
              color="success"
              text="بله"
            />
          </div>
          <div className="">
            <MuiButton
              // onClick={() => props.onClick()}
              variant="outlined"
              color="secondary"
              text="خیر"
            />
          </div>
        </div>
      </MuiModal>
    </>
  );
};

export default ReturnModal;
